import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Single source of truth for a user's landing route. Returns "/login" for
// unauthenticated OR unrecognised roles so the router can never ping-pong
// between "/" and a role-protected route (which white-screens Safari via the
// history.replaceState throttle).
export function homePath(user) {
  if (!user) return "/login";
  if (user.role === "volunteer") return "/dashboard";
  if (user.role === "planner" || user.role === "admin") return "/planner";
  return "/login";
}

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === undefined)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  if (user === null) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const target = homePath(user);
    // Guard: if the computed home is itself denied, send to login instead of looping.
    return <Navigate to={roles.includes("volunteer") ? "/login" : target} replace />;
  }
  return children;
}
